import React, { createContext, useEffect, useRef, useState } from 'react';

export const SidebarContext = createContext({});

function SidebarProvider({ children }) {

    const [sidebarState,setSidebarState] = useState(false)

    const handleSidebar = () => {
        setSidebarState(!sidebarState)
    }

    return (
        <SidebarContext.Provider value={{handleSidebar,sidebarState}}>
            {children}
        </SidebarContext.Provider>
    );
}

export default SidebarProvider;
